import React from 'react';
import { Card } from '../components/ui/Card';
import { UserIcon, KeyIcon, ShieldIcon, BellIcon, DatabaseIcon, CloudIcon, ServerIcon } from 'lucide-react';
export const Settings = () => {
  return <div className="space-y-6" data-id="element-944">
      <div data-id="element-945">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-946">Settings</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-947">
          Manage your account settings and system preferences
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-948">
        <div className="md:col-span-1" data-id="element-949">
          <Card data-id="element-950">
            <nav className="space-y-1" data-id="element-951">
              {[{
              name: 'Profile Settings',
              icon: <UserIcon size={20} className="text-gray-500" data-id="element-952" />,
              current: true
            }, {
              name: 'Password & Security',
              icon: <KeyIcon size={20} className="text-gray-500" data-id="element-953" />,
              current: false
            }, {
              name: 'Roles & Permissions',
              icon: <ShieldIcon size={20} className="text-gray-500" data-id="element-954" />,
              current: false
            }, {
              name: 'Notifications',
              icon: <BellIcon size={20} className="text-gray-500" data-id="element-955" />,
              current: false
            }, {
              name: 'Database Backup',
              icon: <DatabaseIcon size={20} className="text-gray-500" data-id="element-956" />,
              current: false
            }, {
              name: 'Cloud Storage',
              icon: <CloudIcon size={20} className="text-gray-500" data-id="element-957" />,
              current: false
            }, {
              name: 'System Maintenance',
              icon: <ServerIcon size={20} className="text-gray-500" data-id="element-958" />,
              current: false
            }].map((item, index) => <a key={index} href="#" className={`flex items-center px-4 py-3 text-sm font-medium rounded-md ${item.current ? 'bg-indigo-50 text-indigo-600' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-959">
                  <span className="mr-3" data-id="element-960">{item.icon}</span>
                  <span data-id="element-961">{item.name}</span>
                </a>)}
            </nav>
          </Card>
        </div>
        <div className="md:col-span-2" data-id="element-962">
          <Card title="Profile Settings" data-id="element-963">
            <form className="space-y-6" data-id="element-964">
              <div className="flex items-center" data-id="element-965">
                <div className="flex-shrink-0" data-id="element-966">
                  <div className="h-20 w-20 rounded-full bg-indigo-100 flex items-center justify-center" data-id="element-967">
                    <span className="text-xl font-medium text-indigo-800" data-id="element-968">
                      AD
                    </span>
                  </div>
                </div>
                <div className="ml-5" data-id="element-969">
                  <button type="button" className="px-3 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" data-id="element-970">
                    Change Photo
                  </button>
                  <p className="mt-1 text-xs text-gray-500" data-id="element-971">
                    JPG, GIF or PNG. Max size of 2MB.
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-972">
                <div className="sm:col-span-3" data-id="element-973">
                  <label htmlFor="first-name" className="block text-sm font-medium text-gray-700" data-id="element-974">
                    First name
                  </label>
                  <div className="mt-1" data-id="element-975">
                    <input type="text" name="first-name" id="first-name" defaultValue="Admin" className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md p-2 border" data-id="element-976" />
                  </div>
                </div>
                <div className="sm:col-span-3" data-id="element-977">
                  <label htmlFor="last-name" className="block text-sm font-medium text-gray-700" data-id="element-978">
                    Last name
                  </label>
                  <div className="mt-1" data-id="element-979">
                    <input type="text" name="last-name" id="last-name" defaultValue="User" className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md p-2 border" data-id="element-980" />
                  </div>
                </div>
                <div className="sm:col-span-4" data-id="element-981">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-982">
                    Email address
                  </label>
                  <div className="mt-1" data-id="element-983">
                    <input id="email" name="email" type="email" defaultValue="admin@college.edu" className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md p-2 border" data-id="element-984" />
                  </div>
                </div>
                <div className="sm:col-span-3" data-id="element-985">
                  <label htmlFor="role" className="block text-sm font-medium text-gray-700" data-id="element-986">
                    Role
                  </label>
                  <div className="mt-1" data-id="element-987">
                    <select id="role" name="role" className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md p-2 border" data-id="element-988">
                      <option data-id="element-989">System Administrator</option>
                      <option data-id="element-990">Department Head</option>
                      <option data-id="element-991">Registrar</option>
                      <option data-id="element-992">Finance Officer</option>
                      <option data-id="element-993">Hostel Warden</option>
                      <option data-id="element-994">Examination Controller</option>
                    </select>
                  </div>
                </div>
                <div className="sm:col-span-6" data-id="element-995">
                  <label htmlFor="about" className="block text-sm font-medium text-gray-700" data-id="element-996">
                    About
                  </label>
                  <div className="mt-1" data-id="element-997">
                    <textarea id="about" name="about" rows={3} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md p-2 border" defaultValue="System administrator responsible for overall ERP management." data-id="element-998" />
                  </div>
                  <p className="mt-2 text-sm text-gray-500" data-id="element-999">
                    Brief description about your role and responsibilities.
                  </p>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-1000">
                <button type="button" className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 mr-3" data-id="element-1001">
                  Cancel
                </button>
                <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" data-id="element-1002">
                  Save Changes
                </button>
              </div>
            </form>
          </Card>
          <Card title="System Information" className="mt-6" data-id="element-1003">
            <div className="space-y-4" data-id="element-1004">
              <div className="flex justify-between py-2 border-b border-gray-100" data-id="element-1005">
                <div className="text-sm font-medium text-gray-500" data-id="element-1006">
                  System Version
                </div>
                <div className="text-sm text-gray-900" data-id="element-1007">College ERP v1.2.4</div>
              </div>
              <div className="flex justify-between py-2 border-b border-gray-100" data-id="element-1008">
                <div className="text-sm font-medium text-gray-500" data-id="element-1009">
                  Last Database Backup
                </div>
                <div className="text-sm text-gray-900" data-id="element-1010">
                  Aug 12, 2023 (2 days ago)
                </div>
              </div>
              <div className="flex justify-between py-2 border-b border-gray-100" data-id="element-1011">
                <div className="text-sm font-medium text-gray-500" data-id="element-1012">
                  Server Status
                </div>
                <div className="text-sm text-green-600 font-medium" data-id="element-1013">
                  Operational
                </div>
              </div>
              <div className="flex justify-between py-2 border-b border-gray-100" data-id="element-1014">
                <div className="text-sm font-medium text-gray-500" data-id="element-1015">
                  Storage Used
                </div>
                <div className="text-sm text-gray-900" data-id="element-1016">1.2 GB / 10 GB</div>
              </div>
              <div className="flex justify-between py-2" data-id="element-1017">
                <div className="text-sm font-medium text-gray-500" data-id="element-1018">
                  Active Users
                </div>
                <div className="text-sm text-gray-900" data-id="element-1019">24 users online</div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
};